import axios from "axios";
import { throwIfNull, throwIfNullOrZeroOrNegative } from "../errors";

const endpoint = 'suppliers';

export default {

    async assignCorpUserAsync({ userId, supplierInternalId }) {
        throwIfNullOrZeroOrNegative(userId, 'userId')
        throwIfNull(supplierInternalId, 'supplierInternalId')
        const response = await axios.post(`${endpoint}/assignCorpUser`, { userId, supplierInternalId })
        return response.data
    },

    async unassignCorpUserAsync({ userId, supplierInternalId }) {
        throwIfNullOrZeroOrNegative(userId, 'userId')
        throwIfNull(supplierInternalId, 'supplierInternalId')
        const response = await axios.post(`${endpoint}/unassignCorpUser`, { userId, supplierInternalId })
        return response.data
    },

    async getFromCurrentUser() {
        const response = await axios.get(`${endpoint}/currentUser`);
        return response.data;
    },

    async getAll() {
        const response = await axios.get(`${endpoint}/getAll`);
        return response.data;
    },

    async getByInternalIdAsync(internalId) {
        const response = await axios.get(`${endpoint}/internalId/${internalId}`)
        return response.data;
    },
}
